import createMuiTheme from "@material-ui/core/styles/createMuiTheme"
import "fontsource-fira-code"

const coderTheme = createMuiTheme({

  typography: {
    fontFamily: "Fira Code, monospace",
  },
  palette: {
    text: {
      primary: '#111111',
      secondary: '#cc179b',
    },
    primary: {
      main: "#1e6ba0",
    },
    secondary: {
      main: "#90457c",
    }
  }
})

export default coderTheme
